export type ProgressDispatch = { id: string; status: string }
export type QtyLine = { uom: string; qty: number }

const DONE = new Set(['receiving_completed', 'reconciled'])
const OPEN = new Set(['dispatched', 'in_transit', 'receiving_draft'])
const EXCLUDED = new Set(['cancelled', 'draft'])

export function isDispatchDone(status: string): boolean {
  return DONE.has(status)
}

export function isDispatchOpen(status: string): boolean {
  return OPEN.has(status)
}

export function isDispatchExcluded(status: string): boolean {
  return EXCLUDED.has(status)
}

export function tripProgress(dispatches: ProgressDispatch[]): { done: number; total: number } {
  let done = 0
  let total = 0
  for (const d of dispatches) {
    if (isDispatchExcluded(d.status)) continue
    total += 1
    if (isDispatchDone(d.status)) done += 1
  }
  return { done, total }
}

export function nextOpenDispatchId(dispatches: ProgressDispatch[]): string | null {
  for (const d of dispatches) {
    if (isDispatchOpen(d.status)) return d.id
  }
  return null
}

export function aggregateLineQtyByUom(lines: QtyLine[]): Record<string, number> {
  const out: Record<string, number> = {}
  for (const line of lines) {
    out[line.uom] = (out[line.uom] ?? 0) + line.qty
  }
  return out
}
